// frontend/src/OnboardingReturnPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function OnboardingReturnPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Optionally: ping backend to refresh user info here
    setTimeout(() => navigate(`/`), 2000);
  }, [navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>✅ Stripe onboarding complete</h2>
      <p>Redirecting home...</p>
    </div>
  );
}

export default OnboardingReturnPage;

